var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp-item",attrs:{"aria-hidden":"true"}},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),(_vm.showValue)?_c('span',{staticClass:"stamp-item-num"},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }